import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2600Model } from './kymw2600.model';
import { GetWPlaceListService } from './api-services/get-w-place-list-service';
import { UploadWPlaceListService } from './api-services/upload-w-place-list-service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileUploadService, FileAccept } from './../../../commons/kymw02/file-upload/file-upload.service';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';

/**
 * Ｗ掲載リスト画面を管理するクラス
 *
 * @export KYMW2600Component
 * @class KYMW2600Component
 */
@Component({
  selector: 'app-kymw2600',
  templateUrl: 'kymw2600.component.html',
  styleUrls: ['kymw2600.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW2600Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;

  // 親画面からの連携値
  param: any;

  // /** ファイルリファレンス */
  public fileRef: File = null;

  kymw2600Model: KYMW2600Model = new KYMW2600Model();

  /**
   *Creates an instance of KYMW2600Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {GetWPlaceListService} getWPlaceListService
   * @param {UploadWPlaceListService} uploadWPlaceListService
   * @param {FileUploadService} fileUploadService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2600Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getWPlaceListService: GetWPlaceListService,
    private uploadWPlaceListService: UploadWPlaceListService,
    private fileUploadService: FileUploadService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2600Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2600';
    this.kymw2600Model.processType		= '1';
    this.kymw2600Model.disabledExecuteToFlg = true;
  }

  /**
   * テキスト入力「受注コード」チェンジイベント
   */
  public eventOrderCode_CHANGEHandler(): void {
    // ボタン「出力」の活性状態を設定
    this.setOutputButtonEnabled();
  }

  /**
   * ボタン「実行」クリックイベントリスナ
   */
  public eventOutput_CLICKHandler(e: Event): void {
    // 選択されているラジオボタンが「出力」の場合
    if (this.kymw2600Model.processType === '1') {
      // VO設定
      const vo = {
        OrderCode: '',
        ClassCode: '',
        CoopCode: ''
      };

      // 受注コード
      vo.OrderCode = this.kymw2600Model.orderCode;
      // 部門コード
      vo.ClassCode = this.kymw2600Model.classCode;
      // 生協コード
      vo.CoopCode = this.kymw2600Model.coopCode;

      // 取得条件チェック
      if (PlessViewUtilsSub.isEmpty(vo.OrderCode)) {
        // Ｗ掲載リストの取得処理が１度も行われていない場合は、取得処理を行わない
        return;
      }
      // Ｗ掲載リスト取得
      this.getWPlaceListService.execute(this.kymw2600Model, vo, (data: any) => {
        // ファイル名の設定
        const fileName = 'Ｗ掲載リスト_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.CSV';

        this.fileDownloadConfirmService.show(data.Filename, fileName);
      });
    // 「取込」の場合
    } else {
      this.eventFileRef_SELECTHandler();
    }
  }

  /**
   * ラジオボタンの選択イベント
   * @param e
   *
   */
  public eventProcessType_CHANGEHandler(): void {
    // 選択されているラジオボタンが「出力」の場合
    if (this.kymw2600Model.processType === '1') {
      // 部門・会員生協を活性
      this.kymw2600Model.disabledMediumToFlg = false;
    } else {
      // 「取込」の場合、部門・会員生協をクリアし、非活性
      this.kymw2600Model.classCode = '';
      this.kymw2600Model.coopCode = '';
      this.kymw2600Model.disabledMediumToFlg = true;
    }
    // 実行ボタン活性化、非活性化設定
    this.setOutputButtonEnabled();
  }

  /**
   * W掲載リスト親子入替情報取込ファイルを選択した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventFileRef_SELECTHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
      const vo = {
        OrderCode: '',
      };
      // 受注コード
      vo.OrderCode		= this.kymw2600Model.orderCode;
      // W掲載リストアップロード
      this.uploadWPlaceListService.execute(selectedFiles[0], vo, (data: any) => {
        const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
        // 画面ＩＤ
        inpVO.dispId = 'KYMW2600';
        // 正常件数
        inpVO.normalNum = data.NormalNum;
        // 注意件数
        inpVO.attentionNum = data.AttentionNum;
        // 異常件数
        inpVO.abnormalNum = data.AbnormalNum;
        // ＤＢ更新件数
        inpVO.updateNum = data.UpdateNum;
        // 処理件数
        inpVO.manageNum = data.ManageNum;

        const ref = this.dialogService.openModal(KYMW0D00Component);
        const inst = ref.componentInstance as KYMW0D00Component;

        inst.parent = this;
        inst.setInterfaceParam(inpVO);
        inst.closeFunction = () => {
          ref.close();
        };
      });
    }
  }, [FileAccept.CSV]);
}

  /**
   * ボタン「実行」の活性状態を設定する。
   */
  public setOutputButtonEnabled(): void {
    // 受注コードが入力されている場合、活性にする
    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      // 参照権限で取込の場合以外は活性化にする
      const readOnly: boolean = this.kymw00Model.kymw1001Model.topFuncReadOnlyMode;
      if (readOnly && this.kymw2600Model.processType === '2') {
        this.kymw2600Model.disabledExecuteToFlg = true;
      } else {
        this.kymw2600Model.disabledExecuteToFlg = false;
      }
    } else {
      this.kymw2600Model.disabledExecuteToFlg = true;
    }
  }
}
